import React from 'react';
import { Link } from 'react-router-dom';
import { Code2, Smartphone, ShieldCheck, Mail } from 'lucide-react';
import { SeoHead } from '../components/common/SeoHead';
import { Button } from '../components/ui/Button';

export const AboutPage: React.FC = () => {

  return (
    <div className="py-12 sm:py-20 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 space-y-16">
      <SeoHead
        title="회사 소개 | About Kapitalletter"
        description="Kapitalletter의 비전, 엔지니어링 철학, 그리고 우리가 모바일 서비스를 만들어가는 방식을 소개합니다."
        canonicalPath="/about"
      />

      {/* Header */}
      <div className="space-y-4">
        <span className="text-xs font-bold text-primary-700 tracking-wider uppercase">
          About Studio
        </span>
        <h1 className="text-3xl sm:text-5xl font-extrabold text-slate-900 tracking-tight">
          단순한 도구를 넘어, 일상의 가치를 높이는 모바일 소프트웨어를 만듭니다.
        </h1>
        <p className="text-lg text-slate-600 leading-relaxed pt-2">
          Kapitalletter는 사용자가 방해받지 않고 자신의 일상에 몰입할 수 있도록 돕는 독립 소프트웨어 개발 스튜디오입니다.
        </p>
      </div>

      {/* Philosophy Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        <div className="bg-white border border-slate-200/90 rounded-2xl p-6 sm:p-8 shadow-xs space-y-3">
          <div className="w-10 h-10 rounded-xl bg-primary-50 text-primary-700 flex items-center justify-center">
            <Smartphone className="w-5 h-5" />
          </div>
          <h2 className="text-xl font-bold text-slate-900">
            사용자 중심의 제품 설계
          </h2>
          <p className="text-sm text-slate-600 leading-relaxed">
            과도한 기능 나열이나 복잡한 설정 대신, 한 번의 터치로 문제를 해결할 수 있는 직관적인 인터페이스와 정제된 인터랙션을 지향합니다.
          </p>
        </div>

        <div className="bg-white border border-slate-200/90 rounded-2xl p-6 sm:p-8 shadow-xs space-y-3">
          <div className="w-10 h-10 rounded-xl bg-primary-50 text-primary-700 flex items-center justify-center">
            <Code2 className="w-5 h-5" />
          </div>
          <h2 className="text-xl font-bold text-slate-900">
            단단하고 지속 가능한 엔지니어링
          </h2>
          <p className="text-sm text-slate-600 leading-relaxed">
            빠른 개발보다 안정적인 코드 품질, 배터리 효율, 가벼운 앱 크기를 우선합니다. 오랜 기간 업데이트되며 신뢰할 수 있는 소프트웨어를 구축합니다.
          </p>
        </div>

        <div className="bg-white border border-slate-200/90 rounded-2xl p-6 sm:p-8 shadow-xs space-y-3">
          <div className="w-10 h-10 rounded-xl bg-primary-50 text-primary-700 flex items-center justify-center">
            <ShieldCheck className="w-5 h-5" />
          </div>
          <h2 className="text-xl font-bold text-slate-900">
            투명한 프라이버시 원칙
          </h2>
          <p className="text-sm text-slate-600 leading-relaxed">
            수익화를 위해 사용자의 개인정보를 판매하거나 무분별한 광고 트래커를 심지 않습니다. 오프라인 우선 로컬 저장을 기본 아키텍처로 삼습니다.
          </p>
        </div>

        <div className="bg-white border border-slate-200/90 rounded-2xl p-6 sm:p-8 shadow-xs space-y-3">
          <div className="w-10 h-10 rounded-xl bg-primary-50 text-primary-700 flex items-center justify-center">
            <Mail className="w-5 h-5" />
          </div>
          <h2 className="text-xl font-bold text-slate-900">
            열린 피드백과 소통
          </h2>
          <p className="text-sm text-slate-600 leading-relaxed">
            스토어 리뷰와 지원 창구를 통해 접수되는 모든 의견은 개발팀이 직접 읽고 제품 로드맵에 적극적으로 반영합니다.
          </p>
        </div>
      </div>

      {/* Call to Actions */}
      <div className="p-8 rounded-2xl bg-slate-50 border border-slate-200 flex flex-col sm:flex-row items-center justify-between gap-6">
        <div>
          <h3 className="font-bold text-slate-900 text-lg">
            새로운 제휴나 서비스 문의가 있으신가요?
          </h3>
          <p className="text-sm text-slate-600 mt-1">
            개발팀 공식 창구로 언제든 편하게 연락해 주세요.
          </p>
        </div>
        <div className="flex items-center gap-3 w-full sm:w-auto">
          <Link to="/contact" className="w-full sm:w-auto">
            <Button variant="primary" size="md" fullWidth>
              문의하기
            </Button>
          </Link>
          <Link to="/apps" className="w-full sm:w-auto">
            <Button variant="outline" size="md" fullWidth>
              앱 둘러보기
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
};
